module.exports = __webpack_public_path__ + "img/sg.3cc134af.png";